module.exports = __webpack_public_path__ + "media/dashboard/assets/images/sidebar/folder-open-4b0e3ec2fee2c7ba3ec444e3cd7f9e6a.svg";